import { render, staticRenderFns } from "./Sound.vue?vue&type=template&id=bee9821a&"
import script from "./Sound.vue?vue&type=script&lang=js&"
export * from "./Sound.vue?vue&type=script&lang=js&"
import style0 from "./Sound.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/xampp/htdocs/sony-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
installComponents(component, {VBtn,VContainer,VFlex,VIcon,VImg,VLayout,VSpacer,VToolbar})
